import { Skeleton } from '../../ui/skeleton'

export function ChartSkeleton({ className = '' }: { className?: string }) {
  return (
    <div className={`flex flex-col w-full ${className}`}>
      <svg
        className='flex-1 w-full h-auto animate-pulse'
        width='776'
        height='218'
        viewBox='0 0 776 218'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0 109C114.636 109 143.295 216.664 257.932 216.664C372.568 216.664 402.33 1.33643 516.966 1.33643C631.602 1.33643 661.364 109 776 109'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </svg>
      <div className='flex items-center w-full px-5 pt-2 justify-between'>
        {Array(6)
          .fill(null)
          .map((_, i) => (
            <Skeleton
              key={`chart-button-loading-${i}`}
              className={`w-12 h-4 rounded-full ${i % 2 === 1 && 'hidden md:block'}`}
              delay={`${i * 150}ms`}
            />
          ))}
      </div>
    </div>
  )
}
